import {
  Alert, AlertDescription, AlertIcon, AlertTitle, CloseButton,
} from '@chakra-ui/react';
import {
  FC, ReactElement, useState, useEffect, useCallback,
} from 'react';

const AlertItem: FC<IAlerterItem> = ({
  title, message, autoDismiss = false, type = 'info', closeToggle = true,
}: Omit<IAlerterItem, 'key'>): ReactElement | null => {
  const dismissTimer = 4500;
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  useEffect(() => {
    let timerId: NodeJS.Timeout | undefined;
    if (autoDismiss && isVisible) {
      timerId = setTimeout(handleClose, dismissTimer);
    }
    return () => {
      if (timerId) {
        clearTimeout(timerId);
      }
    };
  }, [autoDismiss, dismissTimer, handleClose, isVisible]);

  if (!isVisible) {
    return null;
  }

  return (
    <Alert status={type} pr={4}>
      <AlertIcon />
      {title && <AlertTitle mr={2}>{title}</AlertTitle>}
      <AlertDescription pr={6}>{message}</AlertDescription>
      {closeToggle && <CloseButton position="absolute" right={2} top={2} />}
    </Alert>
  );
};

export default AlertItem;
